(() => {
  if (window.dacHeaderLayoutController) {
    window.dacHeaderLayoutController.init();
    return;
  }
  const root = document.documentElement;
  let cleanup;
  function init() {
    cleanup?.();
    const header = document.getElementById('shopify-section-header');
    const inner = header?.querySelector('.header-ios-fix');
    const nav = header?.querySelector('.header-dac');
    if (!inner || !nav) return;
    const mobile = matchMedia('(max-width:1279px)');
    let compact = false, frame = 0, active = true;
    let current = inner.getBoundingClientRect().height;
    let expanded = current;
    let previousExtra = Math.max(0, current - nav.getBoundingClientRect().height);
    let lastOffset = -1, lastBottom = -1;
    function measure() {
      frame = 0;
      if (!active || !header.isConnected) return;
      current = inner.getBoundingClientRect().height;
      const extra = Math.max(0, current - nav.getBoundingClientRect().height);
      expanded = compact ? Math.max(current, expanded + extra - previousExtra) : current;
      previousExtra = extra;
      const gap = mobile.matches && compact ? Math.max(0, expanded - current) : 0;
      header.style.setProperty('--dac-header-reserve', mobile.matches ? expanded + 'px' : '0px');
      header.style.setProperty('--dac-header-shift', gap + 'px');
      if (lastOffset !== current) {
        root.style.setProperty('--dac-header-height', current + 'px');
        lastOffset = current;
      }
      const bottom = header.querySelector('[data-dac-notices-bottom]')?.getBoundingClientRect().height || 0;
      if (lastBottom !== bottom) {
        root.style.setProperty('--dac-header-bottom-height', bottom + 'px');
        lastBottom = bottom;
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
    function scrollState() {
      if (!active || !header.isConnected) return;
      const next = compact ? scrollY > 24 : scrollY > Math.max(160, expanded + 16);
      if (next === compact) return;
      compact = next;
      window.dispatchEvent(new CustomEvent('dac:header-state', {detail:compact}));
      schedule();
    }
    function restore() { scrollState(); schedule(); }
    function breakpoint() {
      compact = false;
      window.dispatchEvent(new CustomEvent('dac:header-state', {detail:false}));
      schedule();
      requestAnimationFrame(scrollState);
    }
    const observer = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    observer?.observe(inner);
    window.addEventListener('scroll', scrollState, {passive:true});
    window.addEventListener('pageshow', restore);
    window.addEventListener('resize', schedule, {passive:true});
    mobile.addEventListener('change', breakpoint);
    cleanup = () => {
      active = false;
      observer?.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', scrollState);
      window.removeEventListener('pageshow', restore);
      window.removeEventListener('resize', schedule);
      mobile.removeEventListener('change', breakpoint);
      header.style.removeProperty('--dac-header-reserve');
      header.style.removeProperty('--dac-header-shift');
      root.style.removeProperty('--dac-header-bottom-height');
      cleanup = null;
    };
    window.dispatchEvent(new CustomEvent('dac:header-state', {detail:false}));
    measure();
    scrollState();
  }
  window.dacHeaderLayoutController = {init};
  document.addEventListener('shopify:section:load', event => {
    if (event.target.id === 'shopify-section-header') init();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.id === 'shopify-section-header') cleanup?.();
  });
  init();
})();
